import { useHistory, useLocation } from "react-router-dom";
import { BulkClassQuery } from "src/api/Class";
import { InstructorsQuery } from "src/api/User";
import BackButton from "src/components/buttons/BackButton";
import { BorderButton } from "src/components/buttons/BorderButton";
import { AddItemHeader } from "src/components/forms/AddItemHeader";
import Container from "src/components/layout/Container";
import { BulkEditCheckoutModal } from "src/components/modals/BulkEditCheckoutModal";
import { useApi } from "src/stores/Api";
import { useStore } from "src/stores/Store";
import { modals } from "src/utils/modals";
import { useSearchParams } from "src/utils/useSearchParams";
import {
  bulkClassVariables,
  instructors,
  userInstructorsVariables,
} from "types/code-generator";

interface Props {}

export default function BulkEditStaff(props: Props) {
  const history = useHistory();
  const location = useLocation();
  const store = useStore();
  const params = useSearchParams();

  const ids = params.getAll("id");
  const excluded = params.has("exclude");

  const instructorsVariables: userInstructorsVariables = {
    organizationId: store.organization.id,
  };

  const queryInstructors = useApi(InstructorsQuery, {
    variables: instructorsVariables,
  });

  const variables: bulkClassVariables = {
    filter: location.search,
    where: {
      organizationId: store.organization.id,
      id:
        ids.length > 0
          ? excluded
            ? { notIn: ids }
            : {
                in: ids,
              }
          : undefined,
    },
  };

  const bulkEditQuery = useApi(BulkClassQuery, {
    variables,
  });

  const counts = bulkEditQuery.bulkClass;
  const instructors = queryInstructors.users || [];

  function onCancel() {
    history.goBack();
  }

  function onNetworkAction() {
    bulkEditQuery.refetch();
  }

  function bulkEditFee(instructor: instructors["users"][0]) {
    modals.show(BulkEditCheckoutModal, {
      field: "instructors",
      counts,
      itemId: instructor.id,
      itemTitle: `${instructor.firstName} ${instructor.lastName}`,
      onNetworkAction,
    });
  }

  // console.log("offering", offering);
  return (
    <>
      <AddItemHeader>
        <Container large>
          <BackButton backText="Return to Bulk Edit" />
          <h2 className="mb-0 flex-1">Staff</h2>
        </Container>
      </AddItemHeader>

      <Container large className="bg-white pb-24 pt-24">
        <Container fullSmall>
          <p className="mb-4 pt-4">
            Select a user to enable or disable for all selected offerings.
          </p>

          <hr className="mb-0" />

          <div className="divide-y divide-borderGray">
            {instructors.map((a) => {
              const count = counts?.instructors[a.id]?.length || 0;

              let enabled = `Enabled on ${count.toLocaleString()} of ${counts?.total.toLocaleString()} selected offering${
                count !== 1 ? "s" : ""
              }.`;

              if (count === counts?.total) {
                enabled = `Enabled on all ${counts?.total.toLocaleString()} selected offering${
                  counts?.total !== 1 && "s"
                }.`;
              }

              return (
                <button
                  key={a.id}
                  className="flex w-full items-center px-4 py-4 text-left"
                  type="button"
                  onClick={() => bulkEditFee(a)}
                >
                  <div className="flex-1 pr-8">
                    <strong className="text-dark">
                      {a.firstName} {a.lastName}
                    </strong>
                    <div className="mb-2 text-sm text-empty">{enabled}</div>
                  </div>
                  <i className="far fa-chevron-right text-organization" />
                </button>
              );
            })}

            <hr className="my-0" />
          </div>

          <div className="pb-12 pt-8">
            <BorderButton onClick={onCancel}>Return to Bulk Edit</BorderButton>
          </div>
        </Container>
      </Container>
    </>
  );
}
